export const getNotificationsPending = () => {
    return {
        type: 'GET_NOTIFICATIONS_PENDING'
    }
};

export const getNotificationsSuccess = notifications => {
    return {
        type: 'GET_NOTIFICATIONS_SUCCESS',
        notifications
    }
};

export const getNotificationsError = error => {
    return {
        type: 'GET_NOTIFICATIONS_ERROR',
        error: error
    }
};

export const getNotifications = userId => {

    const url = userId ? `user_grouped_alerts/${userId}` : 'recent_grouped_alerts';

    return dispatch => {
        dispatch(getNotificationsPending());

        fetch(`${process.env.REACT_APP_API_URL}/${url}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getNotificationsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getNotificationsSuccess(res.groupedAlerts.length ? res.groupedAlerts[0].alerts : []))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
